import { Controller } from "@hotwired/stimulus"
import axios from 'axios';

export default class extends Controller {
  static targets = ["applicationLine", "applicationDetails", "focusBackground", "openDetailsIcon", "categorySelection", "categorySelectionReason", "categorySelectionWarningText", 
    "waitingInfoDialog", "waitingInfoButton", "waitingInfoReasonTitle", "waitingInfoReasonMessage"]
  static values = { applicationId: Number, apartmentId: Number, waitingInfoReason: String }
  isOpened = false;
  applicationDetails = null;
  csrfToken = null;
  axiosClient = null;
  connect() {
    this.csrf_token = $("meta[name=csrf-token]").attr('content');
    this.axiosClient = axios.create({
      headers: {
        "x-csrf-token": this.csrf_token,
        "Content-Type": "application/json"
      }
    });
  }

  async load() {
    if (this.isOpened) {
      await this.fetchData();
      this.applicationDetailsTarget.innerHTML = this.applicationDetails
      this.applicationLineTarget.classList.add("focus-application", "a-item-open")
      this.focusBackgroundTarget.style.display = "block"
    } else {
      this.applicationDetailsTarget.innerHTML = ""
      this.applicationLineTarget.classList.remove("focus-application", "a-item-open")
      this.focusBackgroundTarget.style.display = "none"
    }
  }

  async fetchData() {
    console.log("Fetching data", this.applicationIdValue)
    console.log("Apartment id", this.apartmentIdValue)
    const response = await this.axiosClient.get(`/admin/applications/${this.applicationIdValue}/details?apartment_id=${this.apartmentIdValue}`);
    if (response.status === 200) {
      this.applicationDetails = response.data;
    }
  }

  toggleApplicationDetails() {
    this.isOpened = !this.isOpened;
    this.toggleIcons();
    this.load();
  }

  toggleIcons() {
    this.openDetailsIconTarget.classList.toggle("fa-caret-right")
    this.openDetailsIconTarget.classList.toggle("fa-caret-down")
  }

  async updateCategoryWarning(event) {
    console.log("selected category id", event.target.value)
    const response = await this.axiosClient.get(`/admin/applications/${this.applicationIdValue}/check_category_limits.json?category_id=${event.target.value}`);
    if (response.status === 200) {
      if (response.data.show_warning) {
        console.log("showing warning", response.data.message)
        this.categorySelectionWarningTextTarget.innerHTML = response.data.message
        this.categorySelectionWarningTextTarget.style.color = "default"
        this.categorySelectionReasonTarget.style.display = "block"
      } else {
        console.log("no warning", response.data)
        this.categorySelectionWarningTextTarget.innerHTML = ""
        this.categorySelectionReasonTarget.style.display = "none"
      }
    }
  }

  saveCategory() {
    var categoryId = this.categorySelectionTarget.value;
    var reason = this.categorySelectionReasonTarget.value;
    console.log("selected category id", categoryId);
    if (categoryId) {
      this.axiosClient.put(`/admin/applications/${this.applicationIdValue}/update_category.json`, {
        apartment_application: {category_id: categoryId, category_reason: reason}
      })
      .then(response => {
        if (response.status === 200) {
          console.log("Category updated", response.data);
          this.categorySelectionWarningTextTarget.innerHTML = "Kategoria päivitetty onnistuneesti.";
          this.categorySelectionWarningTextTarget.style.color = "green";
          this.categorySelectionReasonTarget.style.display = "none";
        }
      })
      .catch(error => {
        console.log("Category update failed", error);
        this.categorySelectionWarningTextTarget.innerHTML = "Kategorian päivittämisessä tapahtui virhe.";
        this.categorySelectionWarningTextTarget.style.color = "red";
      });
    } else {
      console.log("No category selected");
      this.categorySelectionWarningTextTarget.innerHTML = "Valitse kategoria ennen tallentamista.";
      this.categorySelectionWarningTextTarget.style.color = "red";
    }
  }

  openWaitingInfoDialog() {
    console.log("Opening waiting info dialog")
    this.waitingInfoDialogTarget.style.display = "block"
    this.waitingInfoButtonTarget.style.display = "none"
  }

  closeWaitingInfoDialog() {
    console.log("Opening waiting info dialog")
    this.waitingInfoDialogTarget.style.display = "none"
    this.waitingInfoButtonTarget.style.display = "block"
  }

  updateWaitingInfoReasonMessage(event) {
    console.log("Reason message", event.target);
    const selectedOption = event.target.options[event.target.selectedIndex];

    this.waitingInfoReasonMessageTarget.value = selectedOption.getAttribute('data-waiting-info-reason-message-value');
  }

  requestAdditionalInfo() {
    console.log("message", this.waitingInfoReasonMessageTarget.value)
    this.axiosClient.put(`/admin/applications/${this.applicationIdValue}/request_additional_info.json`, { apartment_application: { waiting_info_reason: this.waitingInfoReasonTitleTarget.value, waiting_info_message: this.waitingInfoReasonMessageTarget.value } });
    this.toggleApplicationDetails() // Close the details view
    // Hide the application from the list
    const selector = `[data-admin--application-details-application-id-value="${this.applicationIdValue}"]`;
    const listItem = document.querySelector(selector);
    listItem.style.display = "none";
  }
}
